export const ToolInstanceStatusEnum = Object.freeze({
	DRAFT: "draft",
	PUBLISHED: "published",
	ARCHIVED: "archived",
})

